import { TApiResponse } from "@/common/types/response";

import { TMpkRatingState } from "./type";

export function setMpkActivityDetail(state: TMpkRatingState, res: TApiResponse<TMpkRatingState['mpkActivityDetail']>) {
  const { data = {} } = res;
  state.mpkActivityDetail = data;
}


export function setLastTwoEventsForExecutiveDiscipline(state: TMpkRatingState, res: TApiResponse<TMpkRatingState['lastEventsForExecutiveDiscipline']>) {
  const { data = [] } = res;
  state.lastEventsForExecutiveDiscipline = data;
}
